import { FLEX_ELIMINATION } from '@/constants/Common'
import {
  COMPLETED,
  COMPLETED_BRACKET_SOURCE,
  COMPLETED_BRACKET_TARGET,
  INPROGRESS_BRACKET,
  INVALID_AGE_BRACKET,
  INVALID_FORMAT,
  INVALID_PLAYER_GROUP,
  ONGOING,
  REGISTRATION_FULL,
  SAME_BRACKET_MESSAGE,
  SOURCE_BRACKET_VALIDATED,
  TARGET_BRACKET_VALIDATED,
  WAITLIST,
} from '@/constants/MessageConstants'
import { Bracket } from '@/types'

const validateBrackets = (
  current: any,
  selected: any,
  isMale: any,
  isFemale: any,
  isTeamOfBoth: any,
  minAge: any,
  maxAge: any,
  isTeam: any
) => {
  if (current?.elimination === FLEX_ELIMINATION && current?.elimination !== selected?.elimination) {
    return 'Not allowed from Flex to Waterfall/Round Robin League'
  }
  if (current?.elimination !== FLEX_ELIMINATION && selected?.elimination === FLEX_ELIMINATION) {
    return 'Not allowed from Waterfall/Round Robin to Flex League'
  }
  if (current?.displayStatus === COMPLETED) {
    return COMPLETED_BRACKET_SOURCE
  }
  if (selected?.displayStatus === COMPLETED) {
    return COMPLETED_BRACKET_TARGET
  }
  if (selected?.displayStatus === ONGOING || current?.displayStatus === ONGOING) {
    return INPROGRESS_BRACKET
  }
  if (selected?.hasConfirmMatch) {
    return TARGET_BRACKET_VALIDATED
  }
  if (current?.hasConfirmMatch) {
    return SOURCE_BRACKET_VALIDATED
  }
  if (selected?.bracketId === current?.bracketId) {
    return SAME_BRACKET_MESSAGE
  }

  if (selected?.displayStatus === REGISTRATION_FULL) {
    return REGISTRATION_FULL
  }
  if (selected?.displayStatus === WAITLIST) {
    return WAITLIST
  }
  if (current?.format !== selected?.format) {
    return INVALID_FORMAT
  }
  if (isTeam) {
    if (
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'OPEN' &&
        isMale &&
        isFemale &&
        selected?.playerGroup === 'WOMEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'OPEN' &&
        isMale &&
        isFemale &&
        selected?.playerGroup === 'MEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'OPEN' &&
        isMale &&
        selected?.playerGroup === 'WOMEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'OPEN' &&
        isMale &&
        !isFemale &&
        selected?.playerGroup === 'MIXED') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'OPEN' &&
        isFemale &&
        !isMale &&
        selected?.playerGroup === 'MIXED') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'OPEN' &&
        isMale &&
        isFemale &&
        isTeamOfBoth &&
        selected?.playerGroup === 'MIXED') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'OPEN' &&
        isTeamOfBoth &&
        selected?.playerGroup === 'MEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'OPEN' &&
        isTeamOfBoth &&
        selected?.playerGroup === 'WOMEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'OPEN' &&
        isFemale &&
        selected?.playerGroup === 'MEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'MIXED' &&
        isTeamOfBoth &&
        selected?.playerGroup === 'MEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'MIXED' &&
        isTeamOfBoth &&
        selected?.playerGroup === 'WOMEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'MEN' &&
        isMale &&
        selected?.playerGroup === 'WOMEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'MEN' &&
        isMale &&
        selected?.playerGroup === 'MIXED') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'WOMEN' &&
        isFemale &&
        selected?.playerGroup === 'MIXED') ||
      (current?.format === 'DOUBLES' && current?.playerGroup === 'WOMEN' && isFemale && selected?.playerGroup === 'MEN')
    ) {
      return INVALID_PLAYER_GROUP
    }
  }
  if (!isTeam) {
    if (
      (current?.format === 'SINGLES' && current?.playerGroup === 'MEN' && selected?.playerGroup === 'WOMEN') ||
      (current?.format === 'SINGLES' && current?.playerGroup === 'WOMEN' && selected?.playerGroup === 'MEN') ||
      (current?.format === 'SINGLES' &&
        current?.playerGroup === 'OPEN' &&
        isFemale &&
        selected?.playerGroup === 'MEN') ||
      (current?.format === 'SINGLES' &&
        current?.playerGroup === 'OPEN' &&
        isMale &&
        selected?.playerGroup === 'WOMEN') ||
      (current?.format === 'DOUBLES' && current?.playerGroup === 'WOMEN' && selected?.playerGroup === 'MEN') ||
      (current?.format === 'DOUBLES' && current?.playerGroup === 'MEN' && selected?.playerGroup === 'WOMEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'MIXED' &&
        isMale &&
        selected?.playerGroup === 'WOMEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'MIXED' &&
        isFemale &&
        selected?.playerGroup === 'MEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'MIXED' &&
        isFemale &&
        isMale &&
        selected?.playerGroup === 'MEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'MIXED' &&
        isFemale &&
        isMale &&
        selected?.playerGroup === 'WOMEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'OPEN' &&
        isFemale &&
        selected?.playerGroup === 'MEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'OPEN' &&
        isFemale &&
        isMale &&
        selected?.playerGroup === 'MEN') ||
      (current?.format === 'DOUBLES' &&
        current?.playerGroup === 'OPEN' &&
        isFemale &&
        isMale &&
        selected?.playerGroup === 'WOMEN') ||
      (current?.format === 'DOUBLES' && current?.playerGroup === 'OPEN' && isMale && selected?.playerGroup === 'WOMEN')
    ) {
      return INVALID_PLAYER_GROUP
    }
  }
  if (!(minAge >= selected.ageBracket[0] && maxAge <= selected.ageBracket[1])) {
    return INVALID_AGE_BRACKET
  }
  return null
}

export const bracketOptionTeam = (currentBracket: Bracket, selectedData: any, allBrackets: Bracket[]) => {
  const teamAgegroup = selectedData.map((item: any) => {
    return item.age
  })
  const teamsAge = [].concat([], ...teamAgegroup)
  const maxAge = Math.max(...teamsAge)
  const minAge = Math.min(...teamsAge)
  const teamGenders = selectedData.map((team: any) => {
    return team?.gender
  })
  const isTeamOfMale = teamGenders.some((data: any) => data[0] === data[1] && data[0] === 'MALE')
  const isTeamOfFemale = teamGenders.some((data: any) => data[0] === data[1] && data[0] === 'FEMALE')
  const isTeamOfBoth = isTeamOfMale === isTeamOfFemale || (!isTeamOfMale && !isTeamOfFemale)
  const updatedOptions = allBrackets?.map((bracket: any) => {
    return {
      name: bracket.name,
      bracketId: bracket.bracketId,
      isDisable: validateBrackets(
        currentBracket,
        bracket,
        isTeamOfMale,
        isTeamOfFemale,
        isTeamOfBoth,
        minAge,
        maxAge,
        true
      ),
      disableReason: validateBrackets(
        currentBracket,
        bracket,
        isTeamOfMale,
        isTeamOfFemale,
        isTeamOfBoth,
        minAge,
        maxAge,
        true
      ),
    }
  })
  return updatedOptions
}

export const bracketOption = (currentBracket: Bracket, selectedData: any, allBrackets: Bracket[]) => {
  const playersAge = selectedData.map((team: any) => {
    return team?.age
  })
  const minAge = Math.min(...playersAge)
  const maxAge = Math.max(...playersAge)
  const isMale = selectedData.some((data: any) => data.gender === 'MALE')
  const isFemale = selectedData.some((data: any) => data.gender === 'FEMALE')
  const updatedOptions = allBrackets?.map((bracket) => {
    return {
      name: bracket.name,
      bracketId: bracket.bracketId,
      isDisable: validateBrackets(currentBracket, bracket, isMale, isFemale, undefined, minAge, maxAge, false),
      disableReason: validateBrackets(currentBracket, bracket, isMale, isFemale, undefined, minAge, maxAge, false),
    }
  })
  return updatedOptions
}
